import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import TreeItem, { treeItemClasses } from '@mui/lab/TreeItem';

const StyledTreePermissionRow = styled(TreeItem)(({ theme}) => ({
  minHeight: 52,
  width: '100%',

  [`& .${treeItemClasses.content}`]: {
    height: 52,
    width: '100%',
    border: `1px solid ${theme.palette.action.disabled}`,
    borderRadius: 12,
    background: theme.palette.action.default,
    padding: '14px 9px 14px 16px',
    marginBottom: 8,
    '& .Mui-selected.Mui-focused': {
      backgroundColor: theme.palette.action.default
    },

    '& .Mui-selected': {
      backgroundColor: theme.palette.action.default
    },

    '& .Mui-expanded.Mui-focused': {
      backgroundColor: theme.palette.action.default
    },

    '& .MuiTreeItem-content:hover': {
      background: 'none'
    },

    '& > .Mui-selected:hover': {
      background: 'none'
    },
    [`& .${treeItemClasses.label}`]: {
      fontWeight: 'inherit',
      color: 'inherit'
    }
  }
}));

export const CustomPermissionRow = ({ label, ...other }) => {
  return (
    <StyledTreePermissionRow
      label={label}
      data-testid="CustomPermissionRow"
      {...other}
    />
  )
};

CustomPermissionRow.propTypes = {
  label: PropTypes.string.isRequired,
};
